<!--
  @Description 设计变更新增
  @Date 2022-10-20
  @Author liufu
-->
<template>
  <vxe-modal
    v-model="isShow"
    size="mini"
    width="60%"
    height="80%"
    @show="showWindows"
    @close="closeWindows"
    title="添加设计变更"
  >
    <!-- 编辑区域 -->
    <div class="edit-dv">
      <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
        <!-- 第一行 -->
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="问题号" prop="questionNum">
              <el-input
                v-model="form.questionNum"
                autocomplete="off"
                :placeholder="placeholderConfig.relation"
                :disabled="true"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="系统版本" prop="productionVersion">
              <el-input
                v-model="form.productionVersion"
                autocomplete="off"
                :placeholder="placeholderConfig.relation"
                :disabled="true"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="页面" prop="vuePath">
              <el-input
                v-model="form.vuePath"
                autocomplete="off"
                :placeholder="placeholderConfig.relation"
                :disabled="true"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="变更时间" prop="recordTime">
              <el-date-picker
                v-date
                v-model="form.recordTime"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
                type="date"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第二行 -->
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="变更类型" prop="type">
              <el-select clearable v-model="form.type" size="small" placeholder="请选择变更类型">
                <el-option v-for="i of selectOptions.type" :key="i + ''" :label="i" :value="i"></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="需求点" prop="content">
              <el-input v-model="form.content" autocomplete="off" :placeholder="placeholderConfig.input"></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第三行 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="问题内容" prop="questionContent">
              <el-input
                type="textarea"
                :rows="5"
                v-model="form.questionContent"
                autocomplete="off"
                :placeholder="placeholderConfig.relation"
                disabled
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第四行 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="变更内容" prop="designComment">
              <el-input
                type="textarea"
                :rows="10"
                v-model="form.designComment"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 间隔槽（内含保存按钮） -->
    <div class="gap-dv">
      <el-button
        size="small"
        type="primary"
        style="width: 150px"
        :disabled="!$parent.Authority.edit"
        @click="commitDesign()"
        >保存</el-button
      >
    </div>
  </vxe-modal>
</template>

<script>
export default {
  name: 'instructionEdit',
  components: {},
  props: {
    parentObj: Object,
    // 当前数据行id
    id: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      // 弹窗是否打开
      isShow: false,
      form: {
        ykCaseID: '',
        num: '',
        productionType: '',
        productionVersion: '',
        vuePath: '',
        recordTime: '',
        type: '',
        content: '',
        questionContent: '',
        designComment: ''
      },
      // 右键行缓存,用于储存缓存数据打开窗口时初始化值
      row: {},
      rules: {
        type: [{ required: true, message: '请选择变更类型', trigger: 'change' }],
        content: [
          {
            min: 0,
            max: 1000,
            message: '长度应在 0 到 1000 个字符',
            trigger: 'change'
          }
        ],
        designComment: [
          { required: true, message: '请输入变更内容', trigger: 'change' },
          {
            min: 0,
            max: 1000,
            message: '长度应在 0 到 1000 个字符',
            trigger: 'change'
          }
        ]
      },
      // 特殊权限
      spcial: false,
      frontEngineerCache: '',
      backEngineerCache: '',
      techTesterCache: '',
      businessTesterCache: '',
      // 下拉框列表
      combobox: {
        // 说明类型
        result: []
      },
      // 历史说明列表
      historyInsList: [
        // {
        //   type: '提出',
        //   date: '2021-12-20 08:28',
        //   user: '张三',
        //   instruction: '前端处理人修改为李四'
        // },
      ],
      selectOptions: {
        frontEngineer: [],
        backEngineer: [],
        techTester: [],
        businessTester: [],
        type: ['前端', '后端', '数据库']
      }
    }
  },
  methods: {
    // 提交变更
    async commitDesign() {
      const isCanSave = await this.validForm()
      if (!isCanSave) return

      const { data: res } = await this.$http.post('/Common/YKCaseDesign', this.form)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('新增成功!')
      await this.$parent.refresh()
      this.closeModal()
    },
    // 排版问题内容
    handleTypography() {
      if (this.form.content) {
        let cache = this.form.content + ''
        const separator = cache.substring(1, 2)
        const re = new RegExp('([0-9]{1,3}|1000)' + '\\' + separator, 'g')
        const numList = cache.match(re)
        let resultList = []
        if (numList) {
          for (let i = 0; i < numList.length; i++) {
            // numList[i] = Number(String(numList[i]).split(separator)[0])
            if (i === 0) {
              resultList.push(numList[i])
            } else {
              if (
                Number(numList[i].split(separator)[0]) - 1 ===
                Number(resultList[resultList.length - 1].split(separator)[0])
              ) {
                resultList.push(numList[i])
              }
            }
          }
          // resultList = resultList.map(item => {
          //   return String(item) + separator
          // })
          if (resultList) {
            let isFirst = true
            for (let item of resultList) {
              if (isFirst) {
                isFirst = false
              } else {
                cache = cache.replace(item, '\n' + item)
              }
            }
            this.form.content = cache
          } else {
            this.$message.error('没有内容可以排版')
          }
        } else {
          this.$message.error('没有内容可以排版')
        }
      }
    },
    // 监听模态框开启
    async showWindows() {
      this.form = {
        ykCaseID: this.row.id,
        productionType: this.$store.state.productType,
        productionVersion: this.row.productionVersion,
        vuePath: this.row.vuePath,
        recordTime: '',
        type: '',
        content: '',
        designComment: '',
        questionNum: this.row.num,
        questionContent: this.row.content
      }
      this.form.recordTime = this.ykDateFormat('yyyy-MM-dd', new Date())
      // 当前用户职位列表
      const curPosition = String(this.$store.state.userInfo.gangWei)
      if (this.curUserName === '刘坤辉') {
        this.form.type = '数据库'
      } else if (curPosition.includes('前端研发')) {
        this.form.type = '前端'
      } else if (curPosition.includes('后端研发')) {
        this.form.type = '后端'
      }
      this.$nextTick(() => {
        this.$refs['FormRef'].clearValidate()
      })
    },
    // 监听模态框关闭
    closeWindows() {
      this.$refs['FormRef'].resetFields()
    },
    // 校验表单
    async validForm() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      if (!flag) {
        this.$message.error('请正确填写信息')
      }
      return flag
    },
    closeModal() {
      this.isShow = false
    }
  },
  computed: {
    // 当前登录用户名
    curUserName() {
      return this.$store.state.userInfo.userName
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
@history-dv-height: 200px;
@all-dv-width: 98%;
// 编辑说明和历史说明之间的间隔
@dv-margin: 10px;
// 间隔槽总高度 = 高度 + margin
@gap-margin: 10px;
@gap-height: 30px;
@gap-padding-bottom: 10px;
.edit-dv {
  width: @all-dv-width;
  margin: 0 auto;
  height: calc(
    // dv-margin: 需要乘的数值 = 整体区块数量 + 1（如加了一个 gap-dv，则需要 + 1）
      100% - @dv-margin*4 - @gap-height - @gap-margin
  );
  overflow-y: scroll;
  overflow-x: hidden;
}

.edit-dv::-webkit-scrollbar {
  display: none;
}

.gap-dv {
  width: 100%;
  height: @gap-height;
  margin: @gap-margin 0;
  padding-bottom: @gap-padding-bottom;
  // border-bottom: 1px solid #f2f3f5;
  .fl;

  .btn {
    margin: 0 10px;
    width: 180px;
    height: 30px;
    font-size: 14px;
    border-radius: 5px;
    outline: none;
    border: none;
    transition: @normal-transition;
  }

  > button:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  > button:active {
    opacity: 0.9;
  }

  .save-btn {
    background-color: @primary-color;
    color: @text-color;
  }

  .add-btn {
    width: 100px;
    color: #666;
  }

  .del-btn {
    width: 100px;
    background-color: #ff8b8b;
    color: #fff;
  }
}

.btn-dv-prohibit {
  // cursor: not-allowed;
  transition: none !important;
  opacity: 0.5 !important;
  // color: #c0c4cc;
  // border-color: #ebeef5;
  // background-color: #f2f3f5;
}
.btn-dv-prohibit:hover {
  cursor: not-allowed !important;
  opacity: 0.5 !important;
}

.history-dv {
  width: @all-dv-width;
  height: @history-dv-height;
  margin: 10px auto;
  // background-color: #ffcc66;
  overflow-y: scroll;
  box-sizing: border-box;
  font-size: 14px;

  .scrollbar-mixin();

  .history-title {
    font-size: 16px;
    font-weight: bold;
    color: @able-color;
  }

  .history-list-dv {
    width: 97%;
    padding: @dv-margin auto;

    .history-list-item {
      margin: 6px 0;
    }
  }
}

.el-row {
  margin-bottom: 12px !important;
}
</style>
